import React, { useState } from 'react'
import { NavLink } from 'react-router-dom';
import Logo from "../assets/logo.jpg"

const Navigation = () => {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    const Close = () => setClick(false);

    return (
        <div className='navbar_container'>
            <div onClick={() => Close()} />
            <div className="navbar_main">
                <div className="nav-container">
                    <NavLink exact to="/" className="nav_logo">
                        <img src={Logo} alt='Nav-logo' />
                    </NavLink>
                    <div className="nav-icon" onClick={handleClick}>
                        <i className={click ? "fa fa-times" : "fa fa-bars"}></i>
                    </div>
                    
                    <div className={click ? "nav-menu active" : "nav-menu"}>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/drought"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Drought
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/earthquake"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Earthquake
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/cyclone"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Cyclone
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/flood"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Flood
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/lighting"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Lighting
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/epidemics"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Epidemics
                            </NavLink>
                        </div>
                        <div className="nav-item">
                            <NavLink
                                exact
                                to="/contact"
                                activeclassname="active"
                                className="nav-links"
                                onClick={click ? handleClick : null}
                            >
                                Contact Us
                            </NavLink>
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
    )
}

export default Navigation